<template>
  <form @submit.prevent="onSubmit">
    <div class="card-content scrollable">
<!--       <div v-if="organization && organization.logo">
        <figure class="image is-fullwidth">
          <img :src="organization.logo.path" class="logo">
        </figure>
        <br>
      </div> -->
      <b-field label="Name">
        <b-input v-model="form.name"></b-input>
      </b-field>
      <b-field label="Code">
        <b-input v-model="form.councilId"></b-input>
      </b-field>
<!--       <b-field>
        <b-checkbox v-model="form.activityOwner" :true-value="1" :false-value="0">
          Activity Owner
        </b-checkbox>
      </b-field> -->

<!--       <b-field label="Logo">
        <b-upload v-model="form.logo" accept="image/*">
          <b-button size="is-small" icon-left="upload" tag="a">
            <span>{{ form.logo ? form.logo.name : "Choose File" }}</span>
          </b-button>
        </b-upload>
      </b-field> -->

      <tags-input label="Tags" allow-new :values.sync="form.tags" />

      <associated-organizations v-if="organization" :children="form.children" :organization="organization" @submit="onSubmit"/>

<!--       <b-field label="Ratings" v-if="organization && canRate">

        <rating-list :ratings="ratings" :rate="rate" :hide-rate-button="hasRating"/>

      </b-field> -->

    </div>
    <footer class="card-footer">
      <div class="buttons">
        <b-button
          type="is-link"
          native-type="submit"
          class="is-fullwidth"
          :loading="loading"
          :disabled="!organization ? !canManageFirms : false"
        >
          <span v-if="organization">UPDATE</span>
          <span v-else>CREATE</span>
        </b-button>
      </div>
    </footer>
  </form>
</template>

<script>
import RatingList from "@/components/Rating/RatingList";
import TagsInput from "@/components/partials/TagsInput";
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import associatedOrganizations from "./associatedOrganizations";

export default {
  props: {
    height: {
      type: Number,
      default: 500
    },
    organization: {
      type: Object
    }
  },
  components: {
    RatingList,
    TagsInput,
    associatedOrganizations
  },
  data: () => ({
    firmService: FirmService,
    form: {
      name: "",
      councilId: "",
      // activityOwner: 0,
      // permissions: [],
      children: [],
      tags: []
    },
    loading: false,
    archiving: false,
    restoring: false,
    deleting: false
  }),
  computed: {
    scrollableHeight() {
      return this.height - 44 - 56; // header height, footer height
    },
    user() {
      return this.$store.state.Auth.user;
    },
    ratings() {
      return this.organization.ratings || [];
    },
    hasRating() {
      return !!this.ratings.find(rating => rating.createdBy.id == this.user.id);
    },
    canRate() {
      return (
        this.user.firm.id !== this.organization.id &&
        // this.canManageFirms &&
        this.$store.getters["Auth/hasFirmPermission"]("can rate firms")
      );
    },

    canManageFirms() {
      return this.$store.getters["Auth/hasPermission"]("can manage firms");
    }
  },
  watch: {
    organization: {
      handler(organization) {


        if (this.organization) {

          this.firmService.show(this.organization.id, {includes: 'children,tags'}).then(response => {
            const firm = JsonDenormalizer.denormalize(response);

            this.form = {
              name: organization.name,
              councilId: organization.council_id,
              // activityOwner: organization.activity_owner || 0,
              tags: firm.tags ? firm.tags.map(tag => tag.name) : [],
              children: firm.children
                ? firm.children.map(child => child.id)
                : []
            }

          });


          // console.log(x);

          // this.form = {
          //   name: organization.name,
          //   councilId: organization.council_id,
          //   // Fix - There are organizations without children
          //   children: organization.children
          //     ? organization.children.map(child => child.id)
          //     : []
          // }

        } else {
          this.resetForm();
        }
      },
      deep: true
    }
  },
  methods: {

    getChildrens(data) {

      return data.relationships.children.data.map(child => child.id);

      return [];

    },

    transformedData() {
      let formData = new FormData();

      formData.append("name", this.form.name);
      formData.append("council_id", this.form.councilId);
      // formData.append("activity_owner", this.form.activityOwner);

      // if (this.form.logo) {
      //   formData.append("file", this.form.logo);
      // }

      // this.form.permissions.forEach(permission => {
      //   formData.append("permission_ids[]", permission);
      // });

      if (this.organization) {
        this.form.children.forEach(child => {
          formData.append("children[]", child);
        });
      }

      this.form.tags.forEach(tag => {
        formData.append("tags[]", tag);
      });

      formData.append("includes", "children");

      return formData;
    },
    resetForm() {
      this.form = {
        name: "",
        councilId: "",
        // activityOwner: 0,
        tags: []
        // permissions: []
      };
    },
    onSubmit() {
      if (this.organization) {
        this.update();
      } else {
        this.create();
      }
    },
    cancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    async create() {
      this.loading = true;

      try {
        await this.firmService.store(this.transformedData());

        this.$buefy.toast.open({
          message: "Organization has been created.",
          type: "is-info",
          position: "is-top-right"
        });
        this.resetForm();
        this.$emit("create-success");
      } catch (err) {}

      this.loading = false;
    },
    async update() {
      this.loading = true;

      try {
        const response = await this.firmService.postUpdate(
          this.organization.id,
          this.transformedData()
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "Organization has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("update-success", firm);
      } catch (err) {}

      this.loading = false;
    },
    async archive() {
      this.archiving = true;

      try {
        const response = await this.firmService.archive(this.organization.id);
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "Organization has been archived.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("archive-success", firm);
      } catch (err) {}

      this.archiving = false;
    },
    async restore() {
      this.restoring = true;

      try {
        const response = await this.firmService.restore(this.organization.id);
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "Organization has been restored.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("restore-success", firm);
      } catch (err) {}

      this.restoring = false;
    },
    onRemove() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this organization?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove();
        }
      });
    },
    async remove() {
      this.deleting = true;

      try {
        await this.firmService.delete(this.organization.id);

        this.$buefy.toast.open({
          message: "Organization has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("remove-success");
      } catch (err) {}

      this.deleting = false;
    },
    async rate(data) {
      try {
        const firm = await this.firmService.rate(this.organization.id, data).then(response => JsonDenormalizer.denormalize(response));

        if (firm.ratings) {
          this.$set(this.organization, "ratings", firm.ratings);
        }
      } catch (err) {
        throw err;
      }
    }
  },

  mounted() {

    this.form = {
      name: this.organization.name,
    }

  }


};
</script>

<style scoped>
.logo {
  width: 300px !important;
  height: 100px !important;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/organizationForm.vue